/* eslint-env browser */
import { Component, Input, OnInit,  OnDestroy, ChangeDetectorRef, ComponentRef, ViewContainerRef, input, output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { Customer } from '@app/models/customers/Customer';
import { ChamelionOffer } from '@app/models/offerpack/ChamelionOffer';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { ImportService } from '@app/services/import.service';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommentComponent } from '../comment/comment.component';
import { ChamealeonDetailComponent } from '../offerpackdetailmodal/chamaeleon-detail/chamaeleon-detail.component';
import { OfferpackDetailPersComponent } from '../offerpackdetailmodal/offerpack-detail-pers/offerpack-detail-pers.component';

@Component({
    selector: 'clever-offerpackchamaeleoncard',
    templateUrl: './offerpackchamaeleoncard.component.html',
    styleUrls: ['./offerpackchamaeleoncard.component.scss'],
    standalone: false
})
export class OfferpackchamaeleoncardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    readonly offerid = input<string>(undefined);
    @Input() desktopTemplate: string;
    readonly mitEmail = input<string>(undefined);
    readonly mitName = input<string>(undefined);
    readonly mitTel = input<string>(undefined);
    readonly packid = input<string>(undefined);
    readonly online = input<string>(undefined);
    readonly index = input<number>(undefined);
    readonly removeFromList = output<string>();
    readonly changeindex = output<{
    dragedindex: number;
    dropindex: number;
}>();

    currentCustomer: Customer;
    currentpartner: Partner;
    component: ComponentRef<any>;

    showDetail: boolean = false;
    showImmages: boolean = true;

    sendRegSub: Subscription;
    sendBack: Subscription;

    datas: ChamelionOffer;
    dauer: any;
    constructor(
        private auth: AuthService,
        private authguad: AuthGuardService,
        private importService: ImportService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private viewContainerRef: ViewContainerRef,
        protected mediaObserver: BreakpointObserver
    ) {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();

        this.sendRegSub?.unsubscribe();
        this.sendBack?.unsubscribe();
    }

    ngOnInit(): void {
        this.auth.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
        this.authguad.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.currentpartner = partner;
            if (this.currentpartner?.partnerid?.length > 0) {
                this.initData();
            }
        });
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        const index = this.index();
        if (Number(dragedindex) > 0 && Number(dragedindex) !== index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: index - 1 });
        }
    }

    initData() {
        const target = {
            offerid: this.offerid(),
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'getofferbyid').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res && !res.error) {
                if (res.CustomOffer?.Accommodation?.ImageUrls?.ImageUrl?.length > 0 && res.firstBilder?.length > 0) {
                    const pos = res.CustomOffer.Accommodation.ImageUrls.ImageUrl.indexOf(res.firstBilder);
                    res.CustomOffer.Accommodation.ImageUrls.ImageUrl = this.changeBilderPos(res.CustomOffer.Accommodation.ImageUrls.ImageUrl, pos);
                }
                this.datas = res;
                this.datas.CustomOffer.adults = (Number(res?.CustomOffer?.PAX) - (!isNaN(Number(res?.CustomOffer?.ChildrenCount)) ? Number(res?.CustomOffer?.ChildrenCount) : 0)) + '';
                this.datas.firstBilderPos = 0;
                if (this.datas?.CustomOffer?.Accommodation) {
                    this.datas.CustomOffer.Accommodation.DurationDays = moment(this.datas.CustomOffer.Accommodation.EndDate).diff(moment(this.datas.CustomOffer.Accommodation.StartDate), 'days');
                    this.datas.CustomOffer.Accommodation.DurationUnit = 'Tage';
                    if (this.datas.CustomOffer.Accommodation.DurationDays < 1) {
                        this.datas.CustomOffer.Accommodation.DurationUnit = 'Tag';
                    }
                }

                if (this.datas?.CustomOffer?.VideoUrls?.VideoUrl &&
                    !Array.isArray(this.datas.CustomOffer.VideoUrls.VideoUrl)) {
                    this.datas.CustomOffer.VideoUrls.VideoUrl = [this.datas.CustomOffer.VideoUrls.VideoUrl];
                }

                if (this.datas?.CustomOffer?.Accommodation?.ImageUrls?.ImageUrl &&
                    !Array.isArray(this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl)) {
                    this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl = [this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl];
                }
            }
            this.cdr.detectChanges();
        });
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async gotoBuchen() {
        if (this.currentCustomer?.token?.length > 0) {
            window.open(this.datas?.CustomOffer?.BackReference, '_blank', 'noopener');
        } else {
            this.openDetail();
        }
    }

    openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: null,
                images: this.datas?.CustomOffer?.Accommodation?.ImageUrls?.ImageUrl,
                videos: [],
                current: ev,
                to800: false,
                desktopTemplate: this.desktopTemplate,
                showSave: true
            }
        }
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((pos) => {
            if (pos !== this.datas.firstBilderPos) {
                this.datas.firstBilderPos = pos;
                this.saveImagesList();
            }
        });
    }

    gotoOffers() {
        window.open(this.datas?.CustomOffer?.BackReference, '_blank', 'noopener');
    }

    saveImagesList() {
        if (this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl) {
            const target = {
                offerid: this.offerid(),
                firstBilder: this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl[this.datas.firstBilderPos],
                partnerid: this.currentpartner?.partnerid
            };
            this.importService.request(target, 'updateImageList').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                if (res?.error) {
                    console.log(res);
                } else {
                    this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl = this.changeBilderPos(this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl, this.datas.firstBilderPos);
                    this.showImmages = false;
                    this.datas.firstBilderPos = 0;
                    this.cdr.detectChanges();
                    setTimeout(() => {
                        this.showImmages = true;
                        this.cdr.detectChanges();
                    });
                }
                this.cdr.detectChanges();
            });
        }
    }

    changeBilderPos(targetArray, pos): string[] {
        if (targetArray?.length > 0) {
            targetArray.splice(0, 0, targetArray[pos]);
            targetArray.splice(pos + 1, 1);
        }
        return targetArray;
    }

    async openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(ChamealeonDetailComponent);
        this.component.instance.datas = this.datas;
        this.component.instance.id = this.index();
        this.sendRegSub = this.component.instance.sendReg.subscribe((ev) => {
            if (ev) {
                this.setPersComponent();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    async setPersComponent() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendBack?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(OfferpackDetailPersComponent);
        this.component.instance.datas = this.datas;
        this.component.instance.id = this.index();
        this.component.instance.type = 'chamaeleon';
        this.component.instance.mitEmail = this.mitEmail();
        this.component.instance.mitName = this.mitName();
        this.component.instance.mitTel = this.mitTel();
        this.component.instance.packid = this.packid();
        this.component.instance.offerid = this.offerid();
        this.sendBack = this.component.instance.goBack.subscribe((ev) => {
            if (ev) {
                this.openDetail();
            }
        });
        this.cdr.detectChanges();
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }

    async openSetComment() {
        let target = {} as MatDialogConfig;
        if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
            target = {
                width: '600px',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            };
        } else {
            target = {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                // panelClass: 'customModal',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            }
        }
        const resf = this.dialog.open(CommentComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data) {
                this.datas.extracomment = data?.message;
                this.saveComment(this.datas.extracomment);
            }
        });
    }

    saveComment(extracomment) {
        const target = {
            offerid: this.offerid(),
            extracomment: extracomment,
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'saveComment').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                console.log(res);
            }
        });
    }
}
